<template>
	<AspectTableSingleComponents />
</template>

<script>
import AspectTableSingleComponents from './AspectTableSingleComponents/AspectTableSingleComponents'

export default {
	name: "AspectTableSingleAdd",
	components: {
		AspectTableSingleComponents
	}
}
</script>